var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "label-width": "100px",
          "search-btn-span": _vm.colSpan,
          "default-sort": _vm.defaultSort,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          "before-reset-search": _vm.beforeResetSearch,
          "tooltip-config": { contentMethod: false, enterable: true },
          selection: _vm.selection,
        },
        on: {
          "sort-change": _vm.sortChange,
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "baseForm",
              fn: function () {
                return [
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("workOrderList.Number"),
                            prop: "workNo",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              placeholder: _vm.$t("workOrderList.Number"),
                              comma: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleQuery.apply(null, arguments)
                              },
                            },
                            model: {
                              value: _vm.queryParams.workNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "workNo", $$v)
                              },
                              expression: "queryParams.workNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("WorkorderType.table.InquiryType"),
                            prop: "consultType",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              "option-list": _vm.consultNameList,
                              placeholder: _vm.$t(
                                "WorkorderType.table.InquiryType"
                              ),
                            },
                            on: { change: _vm.getNextList },
                            model: {
                              value: _vm.queryParams.consultType,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "consultType", $$v)
                              },
                              expression: "queryParams.consultType",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("workOrderList.service"),
                            prop: "workOrderTypeId",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              disabled: !_vm.queryParams.consultType,
                              placeholder: _vm.$t("workOrderList.service"),
                              "option-list": _vm.workOrderTypeIdList,
                            },
                            model: {
                              value: _vm.queryParams.workOrderTypeId,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryParams,
                                  "workOrderTypeId",
                                  $$v
                                )
                              },
                              expression: "queryParams.workOrderTypeId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("table.createTimeText") } },
                        [
                          _c("BjDateRangePicker", {
                            attrs: {
                              placeholder: _vm.$t("table.createTimeText"),
                            },
                            model: {
                              value: _vm.queryParams_createTime,
                              callback: function ($$v) {
                                _vm.queryParams_createTime = $$v
                              },
                              expression: "queryParams_createTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("workOrderList.Completion") },
                        },
                        [
                          _c("BjDateRangePicker", {
                            attrs: {
                              placeholder: _vm.$t("workOrderList.Completion"),
                            },
                            model: {
                              value: _vm.queryParams_endTime,
                              callback: function ($$v) {
                                _vm.queryParams_endTime = $$v
                              },
                              expression: "queryParams_endTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            !_vm.closeType
              ? {
                  key: "beforeSearchBtn",
                  fn: function () {
                    return [
                      _c(
                        "el-col",
                        { attrs: { span: 24 - _vm.colSpan } },
                        [
                          _c(
                            "el-tabs",
                            {
                              attrs: { value: _vm.tabIndex, type: "card" },
                              on: { "tab-click": _vm.handleTabClick },
                            },
                            _vm._l(
                              _vm.CSG_WORK_ORDER_LIST_USER_OPEN,
                              function (item, index) {
                                return _c("el-tab-pane", {
                                  key: index,
                                  attrs: {
                                    label: _vm.$t(item.label),
                                    name: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : {
                  key: "beforeSearchBtn",
                  fn: function () {
                    return [
                      _c(
                        "el-col",
                        { attrs: { span: 24 - _vm.colSpan } },
                        [
                          _c(
                            "el-tabs",
                            {
                              attrs: { value: _vm.tabIndex, type: "card" },
                              on: { "tab-click": _vm.handleTabClick },
                            },
                            _vm._l(
                              _vm.CSG_WORK_ORDER_LIST_USER_CLOSE,
                              function (item, index) {
                                return _c("el-tab-pane", {
                                  key: index,
                                  attrs: {
                                    label: _vm.$t(item.label),
                                    name: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
            {
              key: "tableOperation",
              fn: function () {
                return [
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onAdd },
                        },
                        [_vm._v(_vm._s(_vm.$t("addText")))]
                      ),
                      _c("BjFrontendExport", {
                        attrs: {
                          type: "primary",
                          "label-list": _vm.exportLabelList,
                          rows: _vm.selectedRows,
                          "file-name": "workOrders.csv",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "tableColumn",
              fn: function () {
                return [
                  _vm._l(_vm.dropCols, function (col, index) {
                    return [
                      col.prop !== "bjTableAction"
                        ? _c("el-table-column", {
                            key:
                              "col_" +
                              index +
                              "_" +
                              col.prop +
                              "_" +
                              (col.width || "auto"),
                            attrs: {
                              prop: col.prop,
                              label: col.label,
                              width: col.width || "auto",
                              fixed: col.fixed || false,
                              align: "center",
                              "class-name": "item",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      false
                                        ? void 0
                                        : col.prop == "cusId"
                                        ? [
                                            _vm._v(
                                              _vm._s(
                                                _vm.customerList.bjGet(
                                                  scope.row.cusId
                                                )
                                              )
                                            ),
                                          ]
                                        : col.prop === "outerOrderNo"
                                        ? [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(scope.row.webReference)
                                              ),
                                            ]),
                                            _c("BjCopyIcon", {
                                              attrs: {
                                                copy: scope.row.webReference,
                                              },
                                            }),
                                          ]
                                        : col.prop === "exigency"
                                        ? [
                                            scope.row.exigency
                                              ? _c("el-tag", [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row[col.prop]
                                                        ? _vm.$t(
                                                            _vm.CSG_WORK_ORDER_EXIGENCY.bjGet(
                                                              scope.row[
                                                                col.prop
                                                              ]
                                                            )
                                                          )
                                                        : ""
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        : col.prop === "status"
                                        ? [
                                            _c("el-tag", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.CSG_WORK_ORDER_STATUS_USER.bjGet(
                                                      scope.row[col.prop]
                                                    )
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        : col.prop === "pause"
                                        ? [
                                            scope.row.pause
                                              ? _c("el-tag", [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row[col.prop]
                                                        ? _vm.$t(
                                                            _vm.CSG_WORK_ORDER_PAUSE.bjGet(
                                                              scope.row[
                                                                col.prop
                                                              ]
                                                            )
                                                          )
                                                        : ""
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("timeFilters")(
                                                  scope.row[col.prop],
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ),
                                          ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _vm._e(),
                      col.prop === "bjTableAction"
                        ? _c("el-table-column", {
                            key:
                              "col_" +
                              index +
                              "_" +
                              col.prop +
                              "_" +
                              (col.width || "auto"),
                            attrs: {
                              prop: col.prop,
                              label: col.label,
                              width: col.width || "auto",
                              fixed: col.fixed || "right",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (props) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "edit-btn",
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onView(props.row)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("viewText")))]
                                      ),
                                      _c(
                                        "el-dropdown",
                                        {
                                          directives: [
                                            {
                                              name: "hasDropdownChildren",
                                              rawName: "v-hasDropdownChildren",
                                            },
                                          ],
                                          attrs: {
                                            disabled: [5, 7, 9].includes(
                                              props.row.status
                                            ),
                                          },
                                          on: {
                                            command: function ($event) {
                                              return _vm.command(
                                                $event,
                                                props.row
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "el-dropdown-link" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "AccountManagement.common.operate"
                                                  )
                                                )
                                              ),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-arrow-down el-icon--right",
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "el-dropdown-menu",
                                            {
                                              attrs: { slot: "dropdown" },
                                              slot: "dropdown",
                                            },
                                            [
                                              [1, 2, 6].includes(
                                                props.row.status
                                              )
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      attrs: {
                                                        command: "edit",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("editText")
                                                        ) + " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              [1].includes(props.row.status)
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      attrs: {
                                                        command: "delete",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t("delText")
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              [1, 6].includes(props.row.status)
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      attrs: {
                                                        command: "submit",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "workOrderList.WOSubmit"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              [2, 3, 6].includes(
                                                props.row.status
                                              )
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      attrs: {
                                                        command: "invalid",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "workOrderList.to"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _vm._e(),
                    ]
                  }),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }